export const FIELD_ERROR_CLASS = 'field-error';
//# sourceMappingURL=field-error-class.js.map